<template>
<div class="chapter">
<div class="inner_page">
<p class="toc2"><span><b>CONTENTS</b></span></p>
<p class="toc2"><a href="#/Book1/1cover">SUMMER OF ’49</a></p>
<p class="toc1"><a href="#/Book1/8chap2#chap2">CHAPTER 1</a></p>
<p class="toc1"><a href="#/Book1/9chap3#chap3">CHAPTER 2</a></p>
<p class="toc1"><a href="#/Book1/10chap4#chap4">CHAPTER 3</a></p>
<p class="toc1"><a href="#/Book1/11chap5#chap5">CHAPTER 4</a></p>
<p class="toc1"><a href="#/Book1/12chap6#chap6">CHAPTER 5</a></p>
<p class="toc1"><a href="#/Book1/13chap7#chap7">CHAPTER 6</a></p>
<p class="toc1"><a href="#/Book1/14chap8#chap8">CHAPTER 7</a></p>
<p class="toc1"><a href="#/Book1/15chap9#chap9">CHAPTER 8</a></p>
<p class="toc1"><a href="#/Book1/16chap10#chap10">CHAPTER 9</a></p>
<p class="toc1"><a href="#/Book1/17chap11#chap11">CHAPTER 10</a></p>
<p class="toc1"><a href="#/Book1/18chap12#chap12">CHAPTER 11</a></p>
<p class="toc1"><a href="#/Book1/19chap13#chap13">CHAPTER 12</a></p>
<p class="toc1"><a href="#/Book1/20chap14#chap14">CHAPTER 13</a></p>
<p class="toc1"><a href="#/Book1/21chap15#chap15">CHAPTER 14</a></p>
<p class="toc1"><a href="#/Book1/22chap16#chap16">CHAPTER 15</a></p>
<p class="toc1"><a href="#/Book1/23chap17#chap17">EPILOGUE</a></p>
<p class="toc1"><a href="#/Book1/24chap18#chap18">AUTHOR'S NOTE</a></p>
<p class="toc1"><a href="#/Book1/26chap20#chap20">BIBLIOGRAPHY</a></p>
<p class="toc1"><a href="#/Book1/27chap21#chap21">INDEX</a></p>
<p class="toc1"><a href="#/Book1/28photo">PHOTO GALLERY</a></p>
<p class="toc2"><a href="#/Book2/1cover">OCTOBER 1964</a></p>
<p class="toc1"><a href="#/Book2/8chap2#chap2">1</a></p>
<p class="toc1"><a href="#/Book2/9chap3#chap3">2</a></p>
<p class="toc1"><a href="#/Book2/10chap4#chap4">3</a></p>
<p class="toc1"><a href="#/Book2/11chap5#chap5">4</a></p>
<p class="toc1"><a href="#/Book2/12chap6#chap6">5</a></p>
<p class="toc1"><a href="#/Book2/13chap7#chap7">6</a></p>
<p class="toc1"><a href="#/Book2/14chap8#chap8">7</a></p>
<p class="toc1"><a href="#/Book2/15chap9#chap9">8</a></p>
<p class="toc1"><a href="#/Book2/16chap10#chap10">9</a></p>
<p class="toc1"><a href="#/Book2/17chap11#chap11">10</a></p>
<p class="toc1"><a href="#/Book2/18chap12#chap12">11</a></p>
<p class="toc1"><a href="#/Book2/19chap13#chap13">12</a></p>
<p class="toc1"><a href="#/Book2/20chap14#chap14">13</a></p>
<p class="toc1"><a href="#/Book2/21chap15#chap15">14</a></p>
<p class="toc1"><a href="#/Book2/22chap16#chap16">15</a></p>
<p class="toc1"><a href="#/Book2/23chap17#chap17">16</a></p>
<p class="toc1"><a href="#/Book2/24chap18#chap18">17</a></p>
<p class="toc1"><a href="#/Book2/25chap19#chap19">18</a></p>
<p class="toc1"><a href="#/Book2/26chap20#chap20">19</a></p>
<p class="toc1"><a href="#/Book2/27chap21#chap21">20</a></p>
<p class="toc1"><a href="#/Book2/28chap22#chap22">21</a></p>
<p class="toc1"><a href="#/Book2/29chap23#chap23">22</a></p>
<p class="toc1"><a href="#/Book2/30chap24#chap24">23</a></p>
<p class="toc1"><a href="#/Book2/31chap25#chap25">24</a></p>
<p class="toc1"><a href="#/Book2/32chap26#chap26">25</a></p>
<p class="toc1"><a href="#/Book2/33chap27#chap27">26</a></p>
<p class="toc1"><a href="#/Book2/34chap28#chap28">27</a></p>
<p class="toc1"><a href="#/Book2/35chap29#chap29">28</a></p>
<p class="toc1"><a href="#/Book2/36chap30#chap30">29</a></p>
<p class="toc1"><a href="#/Book2/37chap31#chap31">30</a></p>
<p class="toc1"><a href="#/Book2/38chap32#chap32">31</a></p>
<p class="toc1"><a href="#/Book2/39chap33#chap33">Epilogue</a></p>
<p class="toc1"><a href="#/Book2/42chap34#chap34">Acknowledgements</a></p>
<p class="toc2"><a href="#/Book3/1cover">THE AMATEURS</a></p>
<p class="toc1"><a href="#/Book3/5start#chap1">Chapter One</a></p>
<p class="toc1"><a href="#/Book3/6chap2#chap2">Chapter Two</a></p>
<p class="toc1"><a href="#/Book3/7chap3#chap3">Chapter Three</a></p>
<p class="toc1"><a href="#/Book3/8chap4#chap4">Chapter Four</a></p>
<p class="toc1"><a href="#/Book3/9chap5#chap5">Chapter Five</a></p>
<p class="toc1"><a href="#/Book3/10chap6#chap6">Chapter Six</a></p>
<p class="toc1"><a href="#/Book3/11chap7#chap7">Chapter Seven</a></p>
<p class="toc1"><a href="#/Book3/12chap8#chap8">Chapter Eight</a></p>
<p class="toc1"><a href="#/Book3/13chap9#chap9">Chapter Nine</a></p>
<p class="toc1"><a href="#/Book3/14chap10#chap10">Chapter Ten</a></p>
<p class="toc1"><a href="#/Book3/15chap11#chap11">Chapter Eleven</a></p>
<p class="toc1"><a href="#/Book3/16chap12#chap12">Chapter Twelve</a></p>
<p class="toc1"><a href="#/Book3/17chap13#chap13">Chapter Thirteen</a></p>
<p class="toc1"><a href="#/Book3/18chap14#chap14">Chapter Fourteen</a></p>
<p class="toc1"><a href="#/Book3/19chap15#chap15">Chapter Fifteen</a></p>
<p class="toc1"><a href="#/Book3/20chap16#chap16">Chapter Sixteen</a></p>
<p class="toc1"><a href="#/Book3/21chap17#chap17">Chapter Seventeen</a></p>
<p class="toc1"><a href="#/Book3/22chap18#chap18">Chapter Eighteen</a></p>
<p class="toc1"><a href="#/Book3/23chap19#chap19">Chapter Nineteen</a></p>
<p class="toc1"><a href="#/Book3/24chap20#chap20">Chapter Twenty</a></p>
<p class="toc1"><a href="#/Book3/25chap21#chap21">Chapter Twenty-One</a></p>
<p class="toc1"><a href="#/Book3/26chap22#chap22">Chapter Twenty-Two</a></p>
<p class="toc1"><a href="#/Book3/27chap23#chap23">Chapter Twenty-Three</a></p>
<p class="toc1"><a href="#/Book3/28chap24#chap24">Chapter Twenty-Four</a></p>
<p class="toc1"><a href="#/Book3/29chap25#chap25">Chapter Twenty-Five</a></p>
<p class="toc1"><a href="#/Book3/30chap26#chap26">Chapter Twenty-Six</a></p>
<p class="toc1"><a href="#/Book3/31chap27#chap27">Chapter Twenty-Seven</a></p>
<p class="toc1"><a href="#/Book3/32chap28#chap28">Chapter Twenty-Eight</a></p>
<p class="toc1"><a href="#/Book3/33chap29#chap29">Chapter Twenty-Nine</a></p>
<p class="toc1"><a href="#/Book3/34chap30#chap30">Chapter Thirty</a></p>
<p class="toc1"><a href="#/Book3/35chap31#chap31">Chapter Thirty-One</a></p>
<p class="toc1"><a href="#/Book3/36chap32#chap32">Chapter Thirty-Two</a></p>
<p class="toc1"><a href="#/Book3/37chap33#chap33">Chapter Thirty-Three</a></p>
<p class="toc1"><a href="#/Book3/38chap34#chap34">Epilogue</a></p>
<p class="toc1"><a href="#/Book3/39chap35#chap35">Image Gallery</a></p>
<p class="toc1"><a href="#/Book3/40chap36#chap36">Acknowledgments</a></p>
<p class="toc2"><a href="#/Book4/1cover">PLAYING FOR KEEPS</a></p>
<p class="toc1"><a href="#/Book4/4start#chap1">1. Paris, October 1997</a></p>
<p class="toc1"><a href="#/Book4/5chap2#chap2">2. Wilmington; Laney High, 1979-1981</a></p>
<p class="toc1"><a href="#/Book4/6chap3#chap3">3. Chicago, November 1997</a></p>
<p class="toc1"><a href="#/Book4/7chap4#chap4">4. Los Angeles, 1997; Williston, North Dakota, 1962</a></p>
<p class="toc1"><a href="#/Book4/8chap5#chap5">5. Chapel Hill, 1980</a></p>
<p class="toc1"><a href="#/Book4/9chap6#chap6">6. Chapel Hill, 1981</a></p>
<p class="toc1"><a href="#/Book4/10chap7#chap7">7. Chapel Hill, 1982-1984</a></p>
<p class="toc1"><a href="#/Book4/11chap8#chap8">8. Chicago, 1984</a></p>
<p class="toc1"><a href="#/Book4/12chap9#chap9">9. New York City; Bristol, Connecticut, 1979-1984</a></p>
<p class="toc1"><a href="#/Book4/13chap10#chap10">10. Chapel Hill; Chicago; Portland, 1984</a></p>
<p class="toc1"><a href="#/Book4/14chap11#chap11">11. Los Angeles; Chicago, 1984, 1985</a></p>
<p class="toc1"><a href="#/Book4/15chap12#chap12">12. Boston, April 1986</a></p>
<p class="toc1"><a href="#/Book4/16chap13#chap13">13. New York City; Portland, 1986</a></p>
<p class="toc1"><a href="#/Book4/17chap14#chap14">14. Chicago, 1986-1987</a></p>
<p class="toc1"><a href="#/Book4/18chap15#chap15">15. Albany; Chicago, 1984-1988</a></p>
<p class="toc1"><a href="#/Book4/19chap16#chap16">16 Chicago; Seattle, 1997</a></p>
<p class="toc1"><a href="#/Book4/20chap17#chap17">17 Hamburg and Conway, Arkansas; Chicago, 1982-1987</a></p>
<p class="toc1"><a href="#/Book4/21chap18#chap18">18. Detroit, the 1980s</a></p>
<p class="toc1"><a href="#/Book4/22chap19#chap19">19. Chicago, 1988-1990; New York City, 1967-1971</a></p>
<p class="toc1"><a href="#/Book4/23chap20#chap20">20. Chicago, 1990-1991</a></p>
<p class="toc1"><a href="#/Book4/24chap21#chap21">21. Chicago; Los Angeles, 1991</a></p>
<p class="toc1"><a href="#/Book4/25chap22#chap22">22. Chicago, 1997-1998</a></p>
<p class="toc1"><a href="#/Book4/26chap23#chap23">23. Chicago; Portland, 1992</a></p>
<p class="toc1"><a href="#/Book4/27chap24#chap24">24. La Jolla; Monte Carlo; Barcelona, 1992</a></p>
<p class="toc1"><a href="#/Book4/28chap25#chap25">25. Chicago; Phoenix, 1992-1993</a></p>
<p class="toc1"><a href="#/Book4/29chap26#chap26">26. Chicago, 1993</a></p>
<p class="toc1"><a href="#/Book4/30chap27#chap27">27. Birmingham; Chicago, 1994-1995</a></p>
<p class="toc1"><a href="#/Book4/31chap28#chap28">28. Chicago; Seattle; Salt Lake City, 1995-1997</a></p>
<p class="toc1"><a href="#/Book4/32chap29#chap29">29. Chicago, 1998</a></p>
<p class="toc1"><a href="#/Book4/33chap30#chap30">30. Chicago; Indianapolis, 1998</a></p>
<p class="toc1"><a href="#/Book4/34chap31#chap31">31. Chicago; Salt Lake City, June 1998</a></p>
<p class="toc1"><a href="#/Book4/35chap32#chap32">32. Chicago, June 1998</a></p>
<p class="toc1"><a href="#/Book4/36chap33#chap33">Epilogue</a></p>
<p class="toc1"><a href="#/Book4/37chap34#chap34">Afterword</a></p>
<p class="toc1"><a href="#/Book4/38chap35#chap35">Image Gallery</a></p>
<p class="toc1"><a href="#/Book4/39chap36#chap36">Acknowledgments</a></p>
<p class="toc1"><a href="#/Book4/40chap37#chap37">Author’s Note</a></p>
<p class="toc1"><a href="#/Book4/41chap38#chap38">List of Interviews</a></p>
<p class="toc2"><span href="#/Comon/author" title="Link target outside of Sample">A Biography of David Halberstam</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?3e420f05